var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 489.637,
    height: 740.14,
    viewBox: "0 0 489.637 740.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.285,
    y1: -0.532,
    x2: -0.071,
    y2: 1.618,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#44bfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#356e9b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DriviLogoPath",
    transform: "translate(-752.576 -223.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sustracci\\xF3n_2",
    "data-name": "Sustracci\\xF3n 2",
    d: "M52.737,304.463a178.3,178.3,0,0,1-38.58-56.781,177.1,177.1,0,0,1-10.5-33.593,179.638,179.638,0,0,1,.691-75.38A177.266,177.266,0,0,1,36.314,70.241a179.373,179.373,0,0,1,25.71-27.277,216.558,216.558,0,0,1,28.817,7.652,170.319,170.319,0,0,1,33.7,15.571A115.372,115.372,0,0,1,154.8,92.324a93.024,93.024,0,0,1,18.509,39.348,70.87,70.87,0,0,1,1.5,14.668,81.167,81.167,0,0,1-1.414,14.73,112.978,112.978,0,0,1-10.1,29.151c-8.457,17.078-21.589,35.111-39.03,53.6-30.532,32.361-64.939,56.2-71.526,60.645Zm260.651-10.9h0a139.515,139.515,0,0,1-12.8-18.326,178.365,178.365,0,0,1-13.271-28.012c-9.709-25.92-14.767-55.857-15.032-88.98-.3-38.127-20.438-72.736-59.84-102.864C180.162,30.7,142.925,15.392,123.6,8.466a177.988,177.988,0,0,1,189.787,285.1Z",
    transform: "translate(819.395 295.788)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Sustracci\\xF3n_1",
    "data-name": "Sustracci\\xF3n 1",
    d: "M244.82,740.14h0l-36.393-55.164c-1.408-2.135-14.291-21.734-32.984-51.824-24.95-40.162-48.268-79.64-69.307-117.338C34.717,387.829,0,299.186,0,244.819,0,109.825,109.826,0,244.821,0A244.666,244.666,0,0,1,489.637,244.821c0,54.372-34.717,143.015-106.136,270.994-21.036,37.7-44.353,77.175-69.3,117.337-18.672,30.055-31.576,49.686-32.986,51.826l-36.391,55.162Zm0-691.511c-111.345,0-201.932,90.322-201.932,201.342s90.586,201.343,201.932,201.343S446.75,360.991,446.75,249.971,356.164,48.628,244.819,48.628Z",
    transform: "translate(752.576 223.7)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bf9a5be1b3cdba75a60d9afa88eaa13c.svg";
export { ForwardRef as ReactComponent };